export const normalizeDateInputValue = (value?: string | null): string => {
    const raw = String(value || "").trim();

    if (!raw) {
        return "";
    }

    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
        return raw;
    }

    const parsed = new Date(raw);
    if (Number.isNaN(parsed.getTime())) {
        return "";
    }

    const year = parsed.getFullYear();
    const month = String(parsed.getMonth() + 1).padStart(2, "0");
    const day = String(parsed.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
};

export const parseDateInputValue = (value?: string | null): Date | null => {
    const normalized = normalizeDateInputValue(value);

    if (!normalized) {
        return null;
    }

    const [year, month, day] = normalized.split("-").map(Number);
    return new Date(year, month - 1, day);
};

export const formatDateInputValue = (value?: Date | null): string => {
    if (!value) {
        return "";
    }

    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, "0");
    const day = String(value.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
};
